import React from 'react';
import {connect} from 'react-redux';

import {openModalFromUrl} from 'utils/modals';

import PageWithoutSideMenu from 'components/PageWithoutSideMenu';
import LoginRequired from 'components/LoginRequired';
import {ConfirmationModal} from 'components/CommonModals';
import {VisibleIfAnyTeamOwner} from 'containers/MyTeams/components/shared';

import {
  UserSection,
  MyTeamsSection,
  TeamBox,
  AllTeamsTable,
  AllStaffMembersTable,
  AddTeamModal,
  InviteNewStaffMemberModal,
  TeamDetailsModal,
  EditTeamDetailsModal,
  ManageTeamPermissionsModal,
  ManageLocationsModal,
  ManageMembersModal,
  InviteNewTeamMemberModal,
  StaffMemberDetailModal,
  SetInactivityLogoutModal
} from './components';

import {
  requiresPermission,
  requiresPermissionOrTeamOwnership,
  PERMISSIONS
} from 'ducks/auth';
import {
  MODALS,
  fetchMyTeams,
  fetchAllTeams,
  fetchStaffMembers,
  selectMyTeams,
  selectAllTeams,
  selectStaffMembers,
  selectMyTeamsLoading,
  selectAllTeamsLoading,
  selectStaffMembersLoading
} from 'ducks/teams';
import {MODALS as BASE_MODALS, openModal, isModalOpen} from 'ducks/modals';

import './styles.css';

class MyTeams extends React.Component<any> {
  componentDidMount() {
    // TODO: Add permission checks
    openModalFromUrl(MODALS, this.props.openModal);

    this.props.fetchMyTeams();
    this.props.fetchAllTeams();
    this.props.fetchStaffMembers();
  }

  openAddTeamModal = () =>
    this.props.requiresPermission({permission: PERMISSIONS.ADD_NEW_TEAM}, () =>
      this.props.openModal(MODALS.ADD_TEAM, {})
    );

  openInviteNewStaffMemberModal = () =>
    this.props.requiresPermission(
      {permission: PERMISSIONS.INVITE_NEW_STAFF_MEMBER},
      () =>
        this.props.openModal(MODALS.INVITE_NEW_STAFF_MEMBER, {
          teams: this.props.allTeams
        })
    );

  openTeamDetailsModal = ({teamId}) => {
    this.props.requiresPermissionOrTeamOwnership(
      {teamId, permission: PERMISSIONS.VIEW_TEAM_DETAILS},
      () => this.props.openModal(MODALS.TEAM_DETAILS, {teamId}, true)
    );
  };

  searchStaffMembers = value => {
    const filters = {search: {value}};
    this.props.fetchStaffMembers({filters});
  };

  openStaffMemberDetailModal = ({memberId}) => {
    this.props.requiresPermission(
      {permission: PERMISSIONS.VIEW_STAFF_MEMBERS_DETAILS},
      () =>
        this.props.openModal(MODALS.STAFF_MEMBER_DETAIL_MODAL, {memberId}, true)
    );
  };

  render() {
    const {
      myTeams,
      allTeams,
      staffMembers,
      addTeamModal,
      inviteNewStaffMemberModal,
      teamDetailsModal,
      editTeamDetailsModal,
      manageTeamPermissionsModal,
      manageTeamLocationsModal,
      manageMembersModal,
      confirmationModal,
      inviteNewTeamMemberModal,
      staffMemberDetailModal,
      setInactivityLogoutModal,
      myTeamsLoading,
      allTeamsLoading,
      staffMembersLoading
    } = this.props;
    return (
      <PageWithoutSideMenu>
        <div className="MyTeams">
          <div className="content">
            <div className="section">
              <UserSection />
            </div>
            <div className="section">
              <MyTeamsSection
                isLoading={myTeamsLoading}
                teams={myTeams.map(team => (
                  <TeamBox
                    key={team.id}
                    name={team.name}
                    avatar={team.avatar}
                    isOwner={team.isOwner}
                    onClick={() => this.openTeamDetailsModal({teamId: team.id})}
                  />
                ))}
              />
            </div>
            <VisibleIfAnyTeamOwner permission={PERMISSIONS.VIEW_ALL_TEAMS}>
              <div className="section">
                <AllTeamsTable
                  teams={allTeams}
                  openAddTeamModal={this.openAddTeamModal}
                  openTeamDetailsModal={this.openTeamDetailsModal}
                  isLoading={allTeamsLoading}
                />
              </div>
            </VisibleIfAnyTeamOwner>
            <VisibleIfAnyTeamOwner
              permission={PERMISSIONS.VIEW_STAFF_MEMBERS_LIST}>
              <div className="section">
                <AllStaffMembersTable
                  staffMembers={staffMembers}
                  teams={allTeams}
                  openInviteNewStaffMemberModal={
                    this.openInviteNewStaffMemberModal
                  }
                  openStaffMemberDetailModal={this.openStaffMemberDetailModal}
                  isLoading={staffMembersLoading}
                />
              </div>
            </VisibleIfAnyTeamOwner>
          </div>

          {addTeamModal && <AddTeamModal />}
          {inviteNewStaffMemberModal && <InviteNewStaffMemberModal />}
          {editTeamDetailsModal && <EditTeamDetailsModal />}
          {teamDetailsModal && <TeamDetailsModal />}
          {manageTeamPermissionsModal && <ManageTeamPermissionsModal />}
          {manageTeamLocationsModal && <ManageLocationsModal />}
          {manageMembersModal && (
            <ManageMembersModal searchStaffMembers={this.searchStaffMembers} />
          )}
          {confirmationModal && <ConfirmationModal />}
          {inviteNewTeamMemberModal && <InviteNewTeamMemberModal />}
          {staffMemberDetailModal && <StaffMemberDetailModal />}
          {setInactivityLogoutModal && <SetInactivityLogoutModal />}
        </div>
      </PageWithoutSideMenu>
    );
  }
}

const mapStateToProps = state => {
  return {
    myTeams: selectMyTeams(state),
    allTeams: selectAllTeams(state),
    staffMembers: selectStaffMembers(state),
    addTeamModal: isModalOpen(state, MODALS.ADD_TEAM),
    inviteNewStaffMemberModal: isModalOpen(
      state,
      MODALS.INVITE_NEW_STAFF_MEMBER
    ),
    teamDetailsModal: isModalOpen(state, MODALS.TEAM_DETAILS),
    editTeamDetailsModal: isModalOpen(state, MODALS.EDIT_TEAM_DETAILS),
    manageTeamPermissionsModal: isModalOpen(
      state,
      MODALS.MANAGE_TEAM_PERMISSIONS
    ),
    manageTeamLocationsModal: isModalOpen(state, MODALS.MANAGE_TEAM_LOCATIONS),
    manageMembersModal: isModalOpen(state, MODALS.MANAGE_MEMBERS),
    inviteNewTeamMemberModal: isModalOpen(state, MODALS.INVITE_NEW_TEAM_MEMBER),
    confirmationModal: isModalOpen(state, BASE_MODALS.CONFIRM),
    staffMemberDetailModal: isModalOpen(
      state,
      MODALS.STAFF_MEMBER_DETAIL_MODAL
    ),
    setInactivityLogoutModal: isModalOpen(state, MODALS.SET_INACTIVITY_LOGOUT),
    myTeamsLoading: selectMyTeamsLoading(state),
    allTeamsLoading: selectAllTeamsLoading(state),
    staffMembersLoading: selectStaffMembersLoading(state)
  };
};

const mapDispatchToProps = {
  fetchMyTeams,
  fetchAllTeams,
  fetchStaffMembers,
  requiresPermission,
  requiresPermissionOrTeamOwnership,
  openModal
};

export default connect(mapStateToProps, mapDispatchToProps)(
  LoginRequired(MyTeams)
);
